import {
  Arr
} from '../Array.lib';
import Core from '../Core';
import {
  compileText,
  trim
} from '../String.lib';

export const TEMPLATE__URL__IMPORT_CONTAINER = (
  '{{API}}/{{BUCKET}}/download/{{KEY}}'
);
export const TEMPLATE__URL__IMPORT_CONTAINER__ORIGINAL_RESUME = (
  '{{API}}/{{BUCKET}}%2F{{KEY}}/download/{{FILENAME}}'
);

export default function translateToImportContainerUrl(url = '') {
  const trimmedUrl = trim(url);

  // Case 1: S3 style 1 - <bucket>.s3.amazonaws.com/<key>
  let match = Arr(trimmedUrl.match(
    /^https?:\/\/([^\.]+)\.s3\.amazonaws\.com\/(.+)$/i
  ));
  if (match[1] && match[2]) {
    console.debug('case 1');
    const AWS_S3_BUCKET = match[1];
    const KEY = match[2];
    return compileText(TEMPLATE__URL__IMPORT_CONTAINER, {
      API: Core.getApi('ImportContainer'),
      BUCKET: AWS_S3_BUCKET,
      KEY
    });
  }

  // Case 2: S3 style 2 - s3.amazonaws.com/<bucket>/<key>
  match = Arr(trimmedUrl.match(
    /^https?:\/\/s3\.amazonaws\.com\/([^\/]+)\/(.+)$/i
  ));
  if (match[1] && match[2]) {
    console.debug('case 2');
    const AWS_S3_BUCKET = match[1];
    const KEY = match[2];
    return compileText(TEMPLATE__URL__IMPORT_CONTAINER, {
      API: Core.getApi('ImportContainer'),
      BUCKET: AWS_S3_BUCKET,
      KEY
    });
  }

  // Case 3: ImportContainer URL (encoded or decoded)
  match = Arr(trimmedUrl.match(
    /^https?:\/\/[^\/]+\/api\/ImportContainer\/(.+?)\/download\/([^\/]+)$/i
  ));
  if (match[1] && match[2]) {
    console.debug('case 3');
    const BUCKET_AND_KEY = decodeURIComponent(match[1]);
    const AWS_S3_BUCKET = BUCKET_AND_KEY.split('/')[0];
    const KEY = BUCKET_AND_KEY.split('/')[1];
    return compileText(TEMPLATE__URL__IMPORT_CONTAINER__ORIGINAL_RESUME, {
      API: Core.getApi('ImportContainer'),
      BUCKET: AWS_S3_BUCKET,
      KEY,
      FILENAME: match[2]
    });
  }

  // Fallback: unchanged
  console.debug('fallback');
  return url;
}
